const L3PlanDate = (initiative) => {
    if (!initiative || !initiative.timeline || !Array.isArray(initiative.timeline)) {
      return null;
    }
    const l1Entry = initiative.timeline.find((entry) => entry.stage === 'L3');
    if(!new Date(l1Entry.date.plan)){
        return null;
    }
    return new Date(l1Entry.date.plan);
  };
  
  export default L3PlanDate;
  